import { mapGetters } from 'vuex'
import { STORE } from '@/constants'

export default {
  computed: {
    ...mapGetters({
      loading: `${STORE.APP.NAME}/${STORE.APP.LOADING}`
    })
  },
  methods: {
    setLoading(value = false) {
      this.$store.commit(
        `${STORE.APP.NAME}/${STORE.APP.LOADING}`,
        value
      )
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.mixin.js